module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Orders":"Bestellungen","Cash Movements":"Kassenbewegungen","Shopping carts":"Warenkörbe","Wish lists":"Wunschlisten","Ordered Items":"Bestellte Artikel","Packing List":"Packliste","Shipping":"Versand","Stock":"Lager"}}')
  delete Component.options._Ctor
}
